import { createClient } from '@supabase/supabase-js'
import { env } from './env'

// Log all environment variables (except sensitive ones)
console.log('Environment variables loaded:', {
  VITE_API_URL: env.VITE_API_URL,
  VITE_SUPABASE_URL: env.VITE_SUPABASE_URL,
  // Don't log ANON_KEY
})

const supabaseUrl = env.VITE_SUPABASE_URL
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables:', {
    hasUrl: !!supabaseUrl,
    hasAnonKey: !!supabaseAnonKey
  })
  throw new Error('Missing Supabase environment variables')
}

/**
 * Where the Supabase session is kept in localStorage. Exported so logout can remove it when
 * `signOut()` fails: supabase-js only deletes it after the server confirms the sign-out (FF-4076).
 */
export const SUPABASE_STORAGE_KEY = 'fanfair-auth'

/**
 * Where supabase-js keeps the PKCE code verifier while a password reset or sign-up email link is
 * pending. supabase-js chooses this name, and `supabase.test.ts` checks that it still uses it.
 * Logout removes it when `signOut()` fails, as supabase-js does after a successful sign-out (FF-4107).
 */
export const SUPABASE_CODE_VERIFIER_KEY = `${SUPABASE_STORAGE_KEY}-code-verifier`

// Ensure we're using the correct URL format
const normalizedSupabaseUrl = supabaseUrl.endsWith('/')
  ? supabaseUrl.slice(0, -1)  // Remove trailing slash if present
  : supabaseUrl

// Log the final Supabase configuration
console.log('Initializing Supabase client:', {
  url: normalizedSupabaseUrl,
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD
})

export const supabase = createClient(normalizedSupabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: SUPABASE_STORAGE_KEY,
    flowType: 'pkce'
  }
})
